import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

let _isMobile = function () {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag;
}

const routes = [
    {
        path: '/',
        redirect: '/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index/index'),
        meta: {title: ''}
    },
    {
        path: '/index-pc',
        name: 'index-pc',
        component: () => import('@/views/index/index-pc'),
        meta: {title: ''}
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/login.vue'),
        meta: {title: ''}
    },
    {
        path: '/login-pc',
        name: 'login-pc',
        component: () => import('@/views/login/login-pc.vue'),
        meta: {title: ''}
    },
    {
        path: '/user-info',
        name: 'user-info',
        component: () => import('@/views/login/user-info.vue'),
        meta: {title: ''}
    },
    {
        path: '/user-info-pc',
        name: 'user-info-pc',
        component: () => import('@/views/login/user-info-pc.vue'),
        meta: {title: ''}
    },
    {
        path: '/code',
        name: 'code',
        component: () => import('@/views/login/code.vue'),
        meta: {title: ''}
    },
    {
        path: '/code-pc',
        name: 'code-pc',
        component: () => import('@/views/login/code-pc.vue'),
        meta: {title: ''}
    },
    {
        path: '/login-code',
        name: 'login-code',
        component: () => import('@/views/login/login-code.vue'),
        meta: {title: ''}
    },
    {
        path: '/skin',
        name: 'skin',
        component: () => import('@/views/skin/skin.vue'),
        meta: {title: ''}
    },
    {
        path: '/explain',
        name: 'explain',
        component: () => import('@/views/explain/explain.vue'),
        meta: {title: ''}
    },
    {
        path: '/explain-pc',
        name: 'explain-pc',
        component: () => import('@/views/explain/explain-pc.vue'),
        meta: {title: ''}
    },
    {
        path: '/answer',
        name: 'answer',
        component: () => import('@/views/answer/answer.vue')
    },
    {
        path: '/answer-pc',
        name: 'answer-pc',
        component: () => import('@/views/answer/answer-pc.vue')
    },
    {
        path: '/activity',
        name: 'activity',
        component: () => import('@/views/activity/activity.vue')
    },
    {
        path: '/activity-pc',
        name: 'activity-pc',
        component: () => import('@/views/activity/activity-pc.vue')
    },
    {
        path: '/result',
        name: 'result',
        component: () => import('@/views/result/result.vue'),
        meta: {title: ''}
    },
    {
        path: '/result-pc',
        name: 'result-pc',
        component: () => import('@/views/result/result-pc.vue'),
        meta: {title: ''}
    },
    {
        path: '/ranking',
        name: 'ranking',
        component: () => import('@/views/ranking/ranking.vue'),
        meta: {title: '排行榜'}
    },
    {
        path: '/ranking-pc',
        name: 'ranking-pc',
        component: () => import('@/views/ranking/ranking-pc.vue'),
        meta: {title: '排行榜'}
    },
    {
        path: '/analysis',
        name: 'analysis',
        component: () => import('@/views/analysis/analysis.vue'),
        meta: {title: '参考答案'}
    },
    {
        path: '/analysis-pc',
        name: 'analysis-pc',
        component: () => import('@/views/analysis/analysis-pc.vue'),
        meta: {title: '做题报告'}
    },
    {
        path: '/review',
        name: 'review',
        component: () => import('@/views/review/review.vue'),
        meta: {title: '评议'}
    },
    {
        path: '/rater',
        name: 'rater',
        component: () => import('@/views/review/rater.vue'),
        meta: {title: '评议详情'}
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    let idNUmb = ''
    to.query.id ? idNUmb = to.query.id : from.query.id
    if (_isMobile()) {
        //移动端
        if(!store.state.isUpdate){
            if(to.path === '/rater'){
                next()
            }else{
                if ( to.path !== '/index' && to.path !== '/index-pc' && from.path === '/') {
                    next('/index' + '?id=' + idNUmb)
                }
            }
        }

        if (to.path.indexOf('-pc') !== -1) {
            next(to.path.replace('-pc', '') + '?id=' + idNUmb)
        } else {
            next()
        }
    } else {
        //pc端
        // if (to.path.indexOf('-pc') !== -1) {
        //     next()
        // } else {
        //     next(to.path + '-pc' + '?id=' + to.query.id)
        // }

        // 暂时屏蔽PC端
        if(!store.state.isUpdate){
            if (to.path !== '/index' && to.path !== '/index-pc' && from.path === '/') {
                next('/index' + '?id=' + idNUmb)
            }
        }

        if (to.path.indexOf('-pc') !== -1) {
            next(to.path.replace('-pc', '') + '?id=' + idNUmb)
        } else {
            next()
        }
    }
    if (to.path === '/activity' && store.state.isSubmit || to.path === '/answer' && store.state.isSubmit || to.path === '/answer-pc' && store.state.isSubmit) {
        next('/index' + '?id=' + idNUmb)
    }

})

export default router
